import CustomerForm from "../createCustomer/customerForm";

const Information = ({
  setCustomerData,
  setPrescriptionsDocsList,
  prescriptionsDocsList,
  customerData,
  cityList,
  customerDocs,
  setCustomerDocs,
  errors,
  setError,
  isEdit,
  totalOutStandingAmount,
  amountDueFifteenDays,
}) => {
  return (
    <div className="max-w-1297">
      <div className="px-4">
        <div className="d-flex align-items-start border-bottom pb-3">
          <div className="d-flex flex-column w-25">
            <h4 className="summary-title mb-1">Summary</h4>
            <p className="summary-label mb-1">Total Outstanding Receivables</p>
            <h4 className="summary-value mb-0">
              ₹ {Number(totalOutStandingAmount).toFixed(2)}
            </h4>
          </div>
          <div className="d-flex flex-column w-75 ps-5 border-start mt-2">
            <p className="summary-label mb-1">Due In Next 15 Days</p>
            <h4 className="summary-value mb-0">₹ {amountDueFifteenDays}</h4>
          </div>
        </div>
      </div>

      <CustomerForm
        setCustomerData={setCustomerData}
        setPrescriptionsDocsList={setPrescriptionsDocsList}
        prescriptionsDocsList={prescriptionsDocsList}
        customerData={customerData}
        cityList={cityList}
        customerDocs={customerDocs}
        setCustomerDocs={setCustomerDocs}
        errors={errors}
        setError={setError}
        isEdit={isEdit}
      />
    </div>
  );
};
export default Information;
